import React from 'react';
import { Route, Redirect, RouteProps } from 'react-router-dom';
import { AuthContext } from '../Context/AuthContext';
import { setLocationRedirectData } from './Helper';

export const RouteAuthGuard = ({ children, ...rest }: RouteProps) => {
  const { isLogged } = React.useContext(AuthContext);

  if (isLogged !== true && rest.location) {
    setLocationRedirectData(rest.location.pathname, rest.location.search);
  }

  return (
    <Route
      {...rest}
      children={() => (isLogged === true ? children : <Redirect to="/login" />)}
    />
  );
};
